import React from 'react';

import { useGetLocationGroupsLazy } from '@occc-app/dataAccessLayer/locationGroup/queries';
import { LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';

import {
  mapLocationGroupsQueryResponseToRawArray,
  mapRawLocationGroupResponseItemToAutocompleteOption,
} from './utils';
import { LocationGroupSelectItem } from './types';

export const LocationGroupSelect: React.FC = () => (
  <LazyAutocompleteFieldNotMultiple<
    LocationGroupSelectItem,
    ReturnType<typeof useGetLocationGroupsLazy>['response']
  >
    name='locationGroup'
    label='Select a location group'
    useLazyQuery={useGetLocationGroupsLazy}
    mapQueryResponseToRawArray={mapLocationGroupsQueryResponseToRawArray}
    mapRawResponseItemToAutocompleteOption={mapRawLocationGroupResponseItemToAutocompleteOption}
    inputProps={{ margin: 'none' }}
    first={100}
  />
);
